import { Badge } from '@travellegacy/nexops-design-system';

/**
 * Utility functions for formatting WhatsApp Groups data
 */

export function getStatusBadge(status?: string) {
  switch (status) {
    case 'OK':
      return <Badge variant="success">Em dia</Badge>;
    case 'AWAITING_REPLY':
      return <Badge variant="warning">Aguardando resposta</Badge>;
    case 'INACTIVE':
      return <Badge variant="default">Sem atividade</Badge>;
    case 'CRITICAL':
      return <Badge variant="error">Crítico</Badge>;
    default:
      return null;
  }
}

export function getSentimentBadge(sentiment: string) {
  switch (sentiment) {
    case 'POSITIVE':
      return <Badge variant="success">Positivo</Badge>;
    case 'NEGATIVE':
      return <Badge variant="error">Negativo</Badge>;
    default:
      return <Badge variant="default">Neutro</Badge>;
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case 'OK':
      return 'Normal';
    case 'ATTENTION':
      return 'Atenção';
    case 'CRITICAL':
      return 'Crítico';
    default:
      return status;
  }
}

export function formatTimeAgo(date?: string | null): string {
  if (!date) return 'Nunca';
  const now = new Date();
  const then = new Date(date);
  const diffMs = now.getTime() - then.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays > 0) return `há ${diffDays}d`;
  if (diffHours > 0) return `há ${diffHours}h`;
  return 'agora';
}
